// extracted by mini-css-extract-plugin
module.exports = {"result":"StatusRecord_result__1Dnvs","odd":"StatusRecord_odd__YBKxz","col":"StatusRecord_col__2r-1j","long":"StatusRecord_long__27ZEp","short":"StatusRecord_short__lvREg"};